import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useTranslationAdmin from "../useTranslationAdmin.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import RefreshButton from "../../common/widgets/RefreshButton.js";
import "./EmployerListBlock.scss";
import EmployerList from "./EmployerList.js";

function EmployerListBlock() {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "EmployerListBlock");

  return (
    <div className="EmployerListBlock">
      <Row>
        <Col>
          <h1>{t("admin:admin_employer_list_title")}</h1>
        </Col>
        <Col className={"button-col"}>
          <RefreshButton />
        </Col>
      </Row>
      <Row>
        <Col>
          <EmployerList />
        </Col>
      </Row>
    </div>
  );
}

export default EmployerListBlock;
